var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.931274 6.9625C0.931274 3.0625 4.34377 0.625 8.00002 0.625C11.3313 0.625 15.0688 2.9 15.0688 6.55625C15.0688 8.9125 13.9313 10.5375 12.0625 11.8375C11.4125 12.325 10.6813 12.8937 10.1125 13.4625C9.54377 14.1937 9.13752 15.0875 9.13752 16.225H5.96877C5.88752 15.8188 5.80627 15.25 5.80627 14.925C5.80627 10.2938 11.4125 9.8875 11.4125 6.6375C11.4125 4.85 9.62502 3.79375 8.08127 3.79375C6.05002 3.79375 4.50627 5.41875 4.50627 7.45C4.50627 7.775 4.50627 8.01875 4.58752 8.2625L1.01252 8.1C0.931274 7.775 0.931274 7.36875 0.931274 6.9625ZM7.59377 23.375C8.81252 23.375 9.86877 22.4 9.86877 21.1812C9.86877 19.9625 8.81252 18.9062 7.59377 18.9062C6.37502 18.9062 5.40002 19.8812 5.40002 21.1812C5.40002 22.4812 6.37502 23.375 7.59377 23.375Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.ff9f1a7c51e0d1df4e168dba65feec40.svg";
export { ForwardRef as ReactComponent };